import { render, staticRenderFns } from "./Base64.vue?vue&type=template&id=2084033a&scoped=true&"
import script from "./Base64.vue?vue&type=script&lang=js&"
export * from "./Base64.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084033a",
  null
  
)

export default component.exports